<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import RoomDetailCanvas from './Part/RoomDetailCanvas.vue';

export default {
  components: {
    Layout,
    PageHeader,
    RoomDetailCanvas
  },
  data() {
    return {
      data: {},
      stuff: [],
      available: [],
      session: [],
    };
  },
  mounted() {
    var vm = this;

    vm.load();
  },
  methods: {
    load() {
      var vm = this;

      if (vm.$route.params.id) {
        vm.create();
      } else {
        vm.newData();

        if (vm.$route.query.store_id) {
          vm.data.store_id = vm.$route.query.store_id;
        }

        if (vm.$route.query.branch_id) {
          vm.data.branch_id = vm.$route.query.branch_id;
        }

        if (vm.$route.query.room_id) {
          vm.data.room_id = vm.$route.query.room_id;
        }

        if (vm.$route.query.stuff_id) {
          vm.data.stuff_id = vm.$route.query.stuff_id;
        }

        if (vm.$route.query.booked_date) {
          vm.data.booked_date = vm.$route.query.booked_date;
        }

        if (vm.$route.query.booked_time) {
          vm.data.booked_time = vm.$route.query.booked_time;
        }

        if (vm.$route.query.session_id) {
          vm.data.session_id = vm.$route.query.session_id;
        }
      }
    },
    newData() {
      var vm = this;

      var data = {
        id: null,
        status_id: null,
        store_id: null,
        branch_id: null,
        session_id: null,
        room_id: null,
        stuff_id: null,
        room: null,
        user_id: null,
        user_name: null,
        user_phone: null,
        user_email: null,
        ref_no: null,
        signin_at: null,
        signout_at: null,
        booked_date: vm.$dateFormat.nowDate(),
        booked_time: null,
        expired_date: null,
        expired_time: null,
      };

      vm.data = Object.assign({}, data);
    },
    async create() {
      var vm = this;

      this.$loading.on('reservation_form_create');
      try {
        vm.newData();

        var resp = await this.$api.Reservation.get(vm.$route.params.id);
        var data = resp.data.data;

        vm.data = data;

        this.$loading.off('reservation_form_create');
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
    async submit() {
      var vm = this;
      this.$loading.on('reservation_form_submit');

      try {
        var postData = vm._createPostData(vm.data);
        var resp = await this.$api.Reservation.create(postData);

        var data = resp.data;

        vm.$router.push({ name: 'reservation-detail', params: { id: data.data } });

        this.$flash.success(data.message);
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
      this.$loading.off('reservation_form_submit');
    },
    _createPostData: function (data) {

      return data;
    },

    //============

    fetchStore: async function (params) {
      const resp = await this.$api.Store.all(params)

      const data = resp.data.data

      const list = data.map(row => ({
        id: row.id,
        text: row.text,
        model: row,
      }))

      const meta = resp.data.meta

      return {
        options: list,
        more: meta.current_page < meta.last_page
      }
    },
    fetchBranch: async function (params) {
      var vm = this;

      var newParams = {
        ...params,
        store_id: vm.data.store_id
      }

      const resp = await this.$api.Branch.all(newParams)

      const data = resp.data.data

      const list = data.map(row => ({
        id: row.id,
        text: row.text,
        model: row,
      }))

      const meta = resp.data.meta

      return {
        options: list,
        more: meta.current_page < meta.last_page
      }
    },
    fetchRoom: async function (params) {
      var vm = this;

      var newParams = {
        ...params,
        branch_id: vm.data.branch_id
      }

      const resp = await this.$api.Room.all(newParams)

      const data = resp.data.data

      const list = data.map(row => ({
        id: row.id,
        text: row.text,
        model: row,
      }))

      const meta = resp.data.meta

      return {
        options: list,
        more: meta.current_page < meta.last_page
      }
    },
    fetchTable: async function (params) {
      var vm = this;

      var newParams = {
        ...params,
        room_id: vm.data.room_id,
        is_static: 0
      }

      const resp = await this.$api.Stuff.all(newParams)

      const data = resp.data.data

      const list = data.map(row => ({
        id: row.id,
        text: row.text,
        model: row,
      }))

      const meta = resp.data.meta

      return {
        options: list,
        more: meta.current_page < meta.last_page
      }
    },
    fetchUser: async function (params) {
      const resp = await this.$api.User.all(params)

      const data = resp.data.data

      const list = data.map(row => ({
        id: row.id,
        text: row.text,
        model: row,
      }))

      const meta = resp.data.meta

      return {
        options: list,
        more: meta.current_page < meta.last_page
      }
    },
    fetchStatus: async function (params) {
      var newParams = {
        ...params,
        group_by: 'reservation_status'
      }

      const resp = await this.$api.Category.all(newParams)

      const data = resp.data.data

      const list = data.map(row => ({
        id: row.id,
        text: row.text,
        model: row,
      }))

      const meta = resp.data.meta

      return {
        options: list,
        more: meta.current_page < meta.last_page
      }
    },
    fetchSession: async function (params) {
      var vm = this;

      var newParams = {
        ...params,
        date: vm.data.booked_date,
        branch_id: vm.data.branch_id,
      }

      const resp = await this.$api.BranchSession.all(newParams)

      const data = resp.data.data

      const list = data.map(row => ({
        id: row.session_id,
        text: row.text,
        model: row,
      }))

      return {
        options: list,
        more: false
      }
    },
    fetchAvailable: async function (created = null) {
      var vm = this;

      var date = vm.data.booked_date;
      if (created)
        date = created;

      if (vm.data.room_id && date && vm.data.session_id) {
        try {
          var newParams = {
            room_id: vm.data.room_id,
            date: date,
            session_id: vm.data.session_id
          }

          const resp = await this.$api.StuffAvailable.all(newParams)

          const data = resp.data.data

          vm.available = data;
        } catch (err) {
          this.$flash.error(err.response.data.message);
        }
      }
    },
    fetchStuff: async function () {
      var vm = this;

      try {
        var newParams = {
          page: 'all',
          room_id: vm.data.room_id,
        }

        const resp = await this.$api.Stuff.all(newParams)

        const data = resp.data.data

        vm.stuff = data;
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
    onSelectStuff(stuff) {
      var vm = this;

      vm.data.stuff_id = stuff.id;
    },
    async onChangeRoom(val, oldVal) {
      var vm = this;

      this.$loading.on('reservation_form_layout_create');
      try {
        await vm.fetchStuff();
        await vm.fetchAvailable();

        if (oldVal != null)
          vm.data.stuff_id = null;

        this.$loading.off('reservation_form_layout_create');
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
    async onChangeDate(date) {
      var vm = this;

      this.$loading.on('reservation_form_layout_create');
      try {
        await vm.fetchAvailable(date);

        vm.data.stuff_id = null;

        this.$loading.off('reservation_form_layout_create');
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
    async onChangeSession(val, oldVal, model) {
      var vm = this;

      vm.data.booked_time = model.sign_in;

      this.$loading.on('reservation_form_layout_create');
      try {
        await vm.fetchAvailable();

        if (oldVal != null)
          vm.data.stuff_id = null;

        this.$loading.off('reservation_form_layout_create');
      } catch (err) {
        this.$flash.error(err.response.data.message);
      }
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="$t('reservation.title.form')" :pageTitle="$t('menu.sub_header.dashboard')" />

    <BRow>
      <BCol lg="3">
        <BRow>
          <BCol lg="12">
            <BCard no-body>
              <BCardHeader>
                <h4 class="card-title mb-0">
                  <i class="mdi mdi-account-outline align-bottom me-1"></i>
                  {{ $t('reservation.label.user') }}
                </h4>
              </BCardHeader>
              <BCardBody>
                <loading :loading="$loading.get('reservation_form_create')" variant="dark" type="block">
                  <b-form @submit="submit()">
                    <BRow>
                      <BCol class="mb-3" lg="12" v-if="$ac.hasAccess('reservation_full_access')">
                        <label class="form-label" for="product-title-input">{{ $t('reservation.label.ref_no') }}</label>
                        <input type="text" class="form-control" v-model="data.ref_no" id="product-title-input"
                          :placeholder="$t('reservation.placeholder.ref_no')" />
                      </BCol>
                      <BCol class="mb-3" lg="12" v-if="$ac.hasAccess('reservation_full_access')">
                        <label for="choices-publish-status-input" class="form-label">{{ $t('reservation.label.user')
                          }}</label>
                        <dynamic-select v-model="data.user_id" :placeholder="$t('reservation.placeholder.user')"
                          :loadOptions="fetchUser" />
                      </BCol>
                      <BCol class="mb-3" lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('reservation.label.user_name')
                          }}</label>
                        <input type="text" class="form-control" v-model="data.user_name" id="product-title-input"
                          :placeholder="$t('reservation.placeholder.user_name')" />
                      </BCol>
                      <BCol class="mb-3" lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('reservation.label.user_phone')
                          }}</label>
                        <input type="text" class="form-control" v-model="data.user_phone" id="product-title-input"
                          :placeholder="$t('reservation.placeholder.user_phone')" />
                      </BCol>
                      <BCol class="mb-3" lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('reservation.label.user_email')
                          }}</label>
                        <input type="email" class="form-control" v-model="data.user_email" id="product-title-input"
                          :placeholder="$t('reservation.placeholder.user_email')" />
                          <span class="badge border border-info text-info text-wrap mt-2 text-start">
                            {{ $t('reservation.notes.user_email') }}
                          </span>
                      </BCol>
                    </BRow>
                    <input type="submit" style="display:none;">
                  </b-form>
                </loading>
              </BCardBody>
            </BCard>
          </BCol>
          <BCol lg="12">
            <BCard no-body>
              <BCardHeader>
                <h5 class="card-title mb-0">
                  <i class="mdi mdi-storefront-outline align-bottom me-1"></i>
                  {{ $t('reservation.label.store') }}
                </h5>
              </BCardHeader>
              <BCardBody>
                <loading :loading="$loading.get('reservation_form_create')" variant="dark" type="block">
                  <BRow>
                    <BCol class="mb-3" lg="12">
                      <label for="choices-publish-status-input" class="form-label">{{
                        $t('reservation.label.store')
                      }}</label>
                      <dynamic-select v-model="data.store_id" :loadOptions="fetchStore"
                        :placeholder="$t('reservation.placeholder.store')" />
                    </BCol>
                    <BCol class="mb-3" lg="12">
                      <label for="choices-publish-status-input" class="form-label">{{
                        $t('reservation.label.branch')
                      }}</label>
                      <dynamic-select v-model="data.branch_id" :placeholder="$t('reservation.placeholder.branch')"
                        :loadOptions="fetchBranch" />
                    </BCol>
                    <BCol class="mb-3" lg="12">
                      <label for="choices-publish-status-input" class="form-label">{{
                        $t('reservation.label.room')
                      }}</label>
                      <dynamic-select v-model="data.room_id" :onChange="onChangeRoom"
                        :placeholder="$t('reservation.placeholder.room')" :loadOptions="fetchRoom" />
                    </BCol>
                    <BCol class="mb-3" lg="12">
                      <label for="choices-publish-status-input" class="form-label">{{
                        $t('reservation.label.booked_date') }}</label>
                      <datepicker v-model="data.booked_date" class="form-control p-0" :onChange="onChangeDate" />
                    </BCol>
                    <BCol class="mb-3" lg="12">
                      <label class="form-label" for="product-title-input">{{
                        $t('reservation.label.session')
                      }}</label>
                      <dynamic-select v-model="data.session_id" :onChange="onChangeSession"
                        :placeholder="$t('reservation.placeholder.session')" :loadOptions="fetchSession"
                        :onDisabled="data.booked_date == null || data.branch_id == null" />
                    </BCol>
                    <BCol class="mb-3" lg="12"
                      v-if="$ac.hasAccess('reservation_full_access')">
                      <label class="form-label">{{ $t('reservation.label.status')
                      }}</label>
                      <dynamic-select v-model="data.status_id" :placeholder="$t('reservation.placeholder.status')"
                        :loadOptions="fetchStatus" />
                    </BCol>
                  </BRow>
                </loading>
              </BCardBody>
            </BCard>
          </BCol>
        </BRow>
      </BCol>
      <BCol xl="9">
        <BRow>
          <BCol xl="12">
            <BCard no-body>
              <BCardHeader>
                <h5 class="card-title mb-0">
                  <i class="mdi mdi-sofa-outline align-bottom me-1"></i>
                  {{ $t('reservation.label.stuff') }}
                </h5>
              </BCardHeader>
              <BCardBody>
                <loading :loading="$loading.get('reservation_form_layout_create')" variant="dark" type="block">
                  <BRow>
                    <BCol lg="12" class="pt-3 border-top border-top-dashed" style="overflow-x: auto;">
                      <div style="min-width: max-content;">
                        <RoomDetailCanvas :stuff_id="data.stuff_id" :is_readonly="false" :stuff="stuff"
                          :available="available" @onSelect="onSelectStuff" :reservation="data" />
                      </div>
                    </BCol>
                  </BRow>
                </loading>
              </BCardBody>
              <BCardFooter v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create')))">
                <b-form @submit="submit()">
                  <div class="hstack gap-2 justify-content-end">
                    <BButton type="submit" variant="success" class="w-100"
                      :disabled="$loading.get('reservation_form_submit')"
                      v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create')))">
                      <loading :loading="$loading.get('reservation_form_submit')">
                        <i class="mdi mdi-floppy me-1"></i>
                        {{ $t('basic.btn.save') }}
                      </loading>
                    </BButton>
                  </div>
                </b-form>
              </BCardFooter>
            </BCard>
          </BCol>
        </BRow>
      </BCol>
    </BRow>
  </Layout>
</template>